<script setup>
import { useIntersectionObserver } from '@vueuse/core'

const backend = useBackend();
const { data: collections } = await useAsyncData(async () => {
  const collections = await backend.getCollections();
  return collections.data || [];
});

const showCollection = ref(false)
const collectionContainer = ref(null)

useIntersectionObserver(
  collectionContainer,
  (entries) => {
    const isIntersecting = entries[0].isIntersecting
    if (isIntersecting) showCollection.value = true
  },
  { threshold: 0.1 }
)
</script>

<template>
  <template v-for="(collection,index) in collections">
    <Container :gray="!(index % 2)" ref="collectionContainer">
      <LazyCarCollection
                     v-if="showCollection"
                     :title="collection.title"
                     :search="collection.search"
                     :href="collection.custom_url ?? collection.slug"
                     :isCustomUrl="!!collection.custom_url"
                     limit="12"
      />
    </Container>
  </template>
</template>
